import { ClearIndicatorProps } from 'react-select';
import { Close16 } from 'ui/icons/action/Close16';
import { CSSProperties } from 'react';
import { colors } from 'ui/theme/colors';
import { SelectIconWrapper } from './Select.styles';
import { BaseOption } from './types';

export const SelectClearIndicator = (props: ClearIndicatorProps<BaseOption>) => {
  const {
    getStyles,
    innerProps: { ref, ...restInnerProps },
  } = props;
  return (
    <div {...restInnerProps} ref={ref} style={getStyles('clearIndicator', props) as CSSProperties}>
      <SelectIconWrapper>
        <Close16 color={colors.iconPrimary} />
      </SelectIconWrapper>
    </div>
  );
};
